(function () {
    'use strict';

/**
 * 
 */
    angular
        .module('configureTrackingColor')
        .service('ConfigureTrackingColorService', ConfigureTrackingColorService);

    function ConfigureTrackingColorService(RemoteService,ConfigureTrackingColorRequestFactory) {
        var self = this;
        
      var model={
    	  colSearchCriteria :ConfigureTrackingColorRequestFactory.getSearchCriteria(),
      	  colorList:[]
      }
        
     var typeList = [
         {title:'Aircraft Model', value: 'aircraftModel'},
         {title:'Event', value: 'event'},
         {title:'Training', value: 'training'},
         {title:'Other', value: 'other'}
      ];

     self.searchTypes = function(){
     	return typeList;
     }
     
     self.setSearchCriteria = function (passSearch) {
         var colorSearch = ConfigureTrackingColorRequestFactory.getSearchCriteria();
         colorSearch.type = passSearch.type.value;
         model.colSearchCriteria = colorSearch;
         
     };
     
     self.getTrackingColors = function(successFn, errorFn){
         RemoteService.searchTrackingColors(model.colSearchCriteria.type).then(
             function (response) {
                 if(response.success){
                     model.colorList = response.colors;
                     successFn(model.colorList);
                 }
             },
             function (error) {
                 errorFn(error.msg[0]);
             }
         );
     };
     
     self.saveColor = function (color, successFn, errorFn) {
         var saveColor = ConfigureTrackingColorRequestFactory.getColorForSave(color);
         RemoteService.saveTrackingColor(saveColor).then(
             function (response) {
                 successFn(response);
             },
             function (error) {
                 errorFn(error.msg[0]);
             }
         );
     };
 
    }
})();